<template>
  <b-card
    class="m-2"
    bg-variant="light"
    no-body
  >
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="warning"
      @dismissed="dismissCountDown=0"
    >
      <strong><span class="fa fa-exclamation-triangle"/> Los Campos con (*) es necesario diligenciarlos</strong>
    </b-alert>
    <b-form @submit="enviar" validated>
      <b-tabs
        v-model="tabIndex"
        align="end"
        active-nav-item-class="bg-light font-wight-bold"
        content-class="mt-3"
        lazy
        card
        justified
      >
        <template v-slot:tabs-start>
          <li
            role="presentation"
            class="nav-item align-self-center mr-auto"
          >
            <h5>
              <span class="fa fa-plus" />
              Nueva Solicitud Credito
            </h5>
          </li>
        </template>
        <b-tab v-if="tabs[0]" lazy>
          <template v-slot:title>
            <h6>
              {{ tabn[0] }}
              <span class="fa fa-long-arrow-right" />
            </h6>
          </template>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Tipo documento:"
                label-for="sltTipoDoc"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltTipoDoc"
                  name="sltTipoDoc"
                  v-model="form.tipoDoc"
                  :options="options.tipoDoc"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Nro. documento:"
                label-for="inpNroDoc"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="number"
                  min="0"
                  v-model="form.nroDoc"
                  id="inpNroDoc"
                  name="inpNroDoc"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Lugar de expedición:"
                label-for="inpLugarExp"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  id="inpLugarExp"
                  name="inpLugarExp"
                  v-model="form.lugarExp"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Fecha de expedición:"
                label-for="inpFechaExp"
                v-bind="propsFormGroup"
              >
                <b-form-datepicker
                  id="inpFechaExp"
                  name="inpFechaExp"
                  v-model="form.fechaExp"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Primer Nombre:"
                label-for="inpNombre1"
              >
                <b-form-input
                  id="inpNombre1"
                  name="inpNombre1"
                  v-model="form.nombre1"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="Segundo Nombre:"
                label-for="inpNombre2"
                v-model="form.nombre1"
              >
                <b-form-input
                  id="inpNombre2"
                  name="inpNombre2"
                  v-model="form.nombre2"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Primer Apellido:"
                label-for="inpApellido1"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  id="inpApellido1"
                  name="inpApellido1"
                  v-model="form.apellido1"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="Segundo Apellido:"
                label-for="inpApellido2"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  id="inpApellido2"
                  name="inpApellido2"
                  v-model="form.apellido2"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="tabs[1]" lazy>
          <template v-slot:title>
            <h6>
              {{ tabn[1] }}
              <span class="fa fa-long-arrow-right" />
            </h6>
          </template>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Fecha de Nacimiento:"
                label-for="inpFechaNac"
                v-bind="propsFormGroup"
              >
                <b-form-datepicker
                  id="inpFechaNac"
                  name="inpFechaNac"
                  v-model="form.fechaNac"
                  :max="mayoredad"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Lugar de Nacimiento:"
                label-for="inpLugarNac"
              >
                <b-form-input
                  id="inpLugarNac"
                  name="inpLugarNac"
                  v-model="form.lugarNac"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Genero:"
                label-for="sltGenero"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltGenero"
                  name="sltGenero"
                  :options="options.genero"
                  v-model="form.genero"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Estado Civil:"
                label-for="sltEstadoCivil"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltEstadoCivil"
                  name="sltEstadoCivil"
                  :options="options.estadoCivil"
                  v-model="form.estadoCivil"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Personas a su cargo:"
                label-for="inpPersonasCargo"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="number"
                  min="0"
                  id="inpPersonasCargo"
                  name="inpPersonasCargo"
                  v-model="form.personasCargo"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Nivel Estudio:"
                label-for="sltNivelEstudio"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltNivelEstudio"
                  name="sltNivelEstudio"
                  :options="options.nivelEstudio"
                  v-model="form.nivelEstudio"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Tipo Vivienda:"
                label-for="sltTipoVivienda"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltTipoVivienta"
                  name="sltTipoVivienta"
                  :options="options.tipoVivienda"
                  v-model="form.tipoVivienda"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Estrato:"
                label-for="sltEstrato"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltEstrato"
                  name="sltEstrato"
                  :options="options.estrato"
                  v-model="form.estrato"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="tabs[2]" lazy>
          <template v-slot:title>
            <h6>
              {{ tabn[2] }}
              <span class="fa fa-long-arrow-right" />
            </h6>
          </template>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Departamento:"
                label-for="inpDepartamento"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltDepartamento"
                  name="sltDepartamento"
                  :options="options.departamento"
                  v-model="form.departamento"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Ciudad:"
                label-for="inpCiudad"
                v-bind="propsFormGroup"
              >
                <b-form-select
                  id="sltCiudad"
                  name="sltCiudad"
                  :options="options.ciudad"
                  v-model="form.ciudad"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Barrio:"
                label-for="inpBarrio"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  id="inpBarrio"
                  name="inpBarrio"
                  v-model="form.barrio"
                  list="my-list-id"
                  required
                />
                <datalist id="my-list-id" v-if="form.barrio.trim()!== ''">
                  <option v-for="barrio in options.barrio" :key="barrio.item">
                    {{ barrio.name }}
                  </option>
                </datalist>
                <!-- b-datalist
                  id="my-list-id"
                  :option="options.barrio"
                  value-field="name"
                  text-field="name"
                /-->
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="(*) Dirección:"
                label-for="inpDireccion"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  id="inpDireccion"
                  name="inpDireccion"
                  v-model="form.direccion"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group
                label="(*) Telefono:"
                label-for="inpTelefono1"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="tel"
                  id="inpTelefono1"
                  name="inpTelefono1"
                  v-model="form.telefono1"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="Celular:"
                label-for="inpTelefono2"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="tel"
                  id="inpTelefono2"
                  name="inpTelefono2"
                  v-model="form.telefono2"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="(*) Correo Electronico:"
                label-for="inpCorreo1"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="email"
                  id="inpCorreo1"
                  name="inpCorreo1"
                  v-model="form.correo1"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="Correo Electronico 2:"
                label-for="inpCorreo2"
                v-bind="propsFormGroup"
              >
                <b-form-input
                  type="email"
                  id="inpCorreo2"
                  name="inpCorreo1"
                  v-model="form.correo2"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="tabs[3]" lazy>
          <template v-slot:title>
            <h6>
              {{ tabn[3] }}
              <span class="fa fa-long-arrow-right" />
            </h6>
          </template>
          <b-row>
            <b-col sm="12">
              <b-table
                v-bind="styleTable"
                :items="items.datosLab"
                :fields="fields.datosLab"
              >
                <template v-slot:table-caption>
                  <h5>(*) Referencias Laborales</h5>
                </template>
                <template v-slot:cell(Ocupacion)="data">
                  <b-form-select
                    :value="data"
                    :options="options.ocupacion"
                    v-model="form.datosLab[data.index].ocupacion"
                    required
                  />
                </template>
                <template v-slot:cell(Empresa)="data">
                  <b-form-input
                    :value="data.item.empresa"
                    v-model="form.datosLab[data.index].empresa"
                    required
                  />
                </template>
                <template v-slot:cell(Cargo)="data">
                  <b-form-input
                    :value="data.item.cargo"
                    v-model="form.datosLab[data.index].cargo"
                    required
                  />
                </template>
                <template v-slot:cell(Salario)="data">
                  <b-form-input
                    type="number"
                    min="0"
                    :value="data.item.salario"
                    v-model="form.datosLab[data.index].salario"
                    required
                  />
                </template>
                <template v-slot:cell(Duracion)="data">
                  <b-form-input
                    :value="data.item.duracion"
                    v-model="form.datosLab[data.index].duracion"
                    required
                  />
                </template>
                <template v-slot:cell(Telefono)="data">
                  <b-form-input
                    type="tel"
                    :value="data.item.telefono"
                    v-model="form.datosLab[data.index].telefono"
                    required
                  />
                </template>
                <template v-slot:cell(Correo)="data">
                  <b-form-input
                    type="email"
                    :value="data.item.correo"
                    v-model="form.datosLab[data.index].correo"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-table
                v-bind="styleTable"
                :items="items.datosFam"
                :fields="fields.datosFam"
              >
                <template v-slot:table-caption>
                  <h5>(*) Referencias Familiares</h5>
                  <strong class="text-primary">Que no convivan con ud</strong>
                </template>
                <template v-slot:cell(Nombres)="data">
                  <b-form-input
                    :value="data.item.nombres"
                    v-model="form.datosFam[data.index].nombres"
                    required
                  />
                </template>
                <template v-slot:cell(Apellidos)="data">
                  <b-form-input
                    :value="data.item.apellidos"
                    v-model="form.datosFam[data.index].apellidos"
                    required
                  />
                </template>
                <template v-slot:cell(Relacion)="data">
                  <b-form-select
                    :value="data"
                    :options="options.relacion"
                    v-model="form.datosFam[data.index].relacion"
                    required
                  />
                </template>
                <template v-slot:cell(Direccion)="data">
                  <b-form-input
                    :value="data.item.Direccion"
                    v-model="form.datosFam[data.index].direccion"
                    required
                  />
                </template>
                <template v-slot:cell(Telefono)="data">
                  <b-form-input
                    type="tel"
                    :value="data.item.telefono"
                    v-model="form.datosFam[data.index].telefono"
                    required
                  />
                </template>
                <template v-slot:cell(Correo)="data">
                  <b-form-input
                    type="email"
                    :value="data.item.correo"
                    v-model="form.datosFam[data.index].correo"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-table
                v-bind="styleTable"
                :items="items.datosPer"
                :fields="fields.datosPer"
              >
                <template v-slot:table-caption>
                  <h5>(*) Referencias Personales</h5>
                </template>
                <template v-slot:cell(Nombres)="data">
                  <b-form-input
                    :value="data.item.nombres"
                    v-model="form.datosPer[data.index].nombres"
                    required
                  />
                </template>
                <template v-slot:cell(Apellidos)="data">
                  <b-form-input
                    :value="data.item.apellidos"
                    v-model="form.datosPer[data.index].apellidos"
                    required
                  />
                </template>
                <template v-slot:cell(Direccion)="data">
                  <b-form-input
                    :value="data.item.Direccion"
                    v-model="form.datosPer[data.index].direccion"
                    required
                  />
                </template>
                <template v-slot:cell(Telefono)="data">
                  <b-form-input
                    type="tel"
                    :value="data.item.telefono"
                    v-model="form.datosPer[data.index].telefono"
                    required
                  />
                </template>
                <template v-slot:cell(Correo)="data">
                  <b-form-input
                    type="email"
                    :value="data.item.correo"
                    v-model="form.datosPer[data.index].correo"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="tabs[4]" lazy>
          <template v-slot:title>
            <h6>
              {{ tabn[4] }}
            </h6>
          </template>
          <h6>Terminos y condiciones</h6>
          <b-card-text class="blockquote text-justify">
            <p class="text-muted">{{ tratamientoDatosPersonales }}</p>
            <p>Confirmo que revisé con anterioridad los <b-link :href="verMas"> Terminos y Condiciones </b-link> referentes al tratamiento de datos personales ?</p>
          </b-card-text>
          <b-form-group>
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
              size="lg"
              required
            >
              Aceptar terminos
            </b-form-checkbox>
          </b-form-group>
        </b-tab>
      </b-tabs>
      <b-row align-h="between">
        <b-col sm="12">
          <b-button
            type="button"
            variant="primary"
            class="m-1 float-right"
            @click="siguiente()"
            v-if="status !== 'accepted'"
            block
          >
            Continuar
            <span class="fa fa-chevron-right" />
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="m-1 float-right"
            v-if="status === 'accepted'"
            block
          >
            <span class="fa fa-paper-plane" />
            Enviar Solicitud
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { Persona, PersonaDatosLab, PersonaDatosFam, PersonaDatosPer } from '@/models/persona'
import { mapActions, mapState } from 'vuex'
// eslint-disable-next-line import/no-named-default
import { default as config } from '@/assets/config/general.json'

export default {
  data () {
    return {
      tabs: [true, false, false, false, false],
      tabn: [
        '1: Datos Personales 1 ',
        '2: Datos Personales 2 ',
        '3: Ubicación ',
        '4: Referencias ',
        '5: Terminos y condiciones '
      ],
      form: new Persona(),
      tabIndex: 0,
      items: {
        datosLab: [{}],
        datosFam: [{}, {}],
        datosPer: [{}, {}]
      },
      fields: {
        datosLab: [
          { key: 'Ocupacion', label: 'Ocupación' },
          { key: 'Empresa', label: 'Nom. Empresa' },
          { key: 'Cargo', label: 'Cargo' },
          { key: 'Salario', label: 'Neto Mensual' },
          { key: 'Duracion', label: 'Duracion (meses)' },
          { key: 'Telefono', label: 'Telefono emp' },
          { key: 'Correo', label: 'Correo emp' }
        ],
        datosFam: [
          { key: 'Nombres', label: 'Nombres' },
          { key: 'Apellidos', label: 'Apellidos' },
          { key: 'Relacion', label: 'Relacion' },
          { key: 'Telefono', label: 'Telefono' },
          { key: 'Direccion', label: 'Direccion' }
        ],
        datosPer: [
          { key: 'Nombres', label: 'Nombres' },
          { key: 'Apellidos', label: 'Apellidos' },
          { key: 'Telefono', label: 'Telefono' },
          { key: 'Direccion', label: 'Direccion' },
          { key: 'Correo', label: 'Correo' }
        ]
      },
      styleTable: {
        striped: true,
        bordered: true,
        borderless: true,
        outlined: true,
        small: false,
        hover: false,
        dark: false,
        responsive: true,
        'sticky-header': false,
        stacked: 'sm',
        'caption-top': true,
        'table-variant': 'light',
        'head-variant': 'dark',
        'foot-variant': 'light',
        'foot-clone': false,
        'no-footer-sorting': false,
        'no-border-collapse': false
      },
      propsFormGroup: {
        'label-size': 'md',
        'label-class': 'font-weight-bold text-muted pt-0'
      },
      tratamientoDatosPersonales: config.datosPersonales.texto,
      verMas: config.datosPersonales.verMas,
      status: 'no_accepted',
      dismissSecs: 3,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  computed: {
    mayoredad () {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

      const maxDate = new Date(today)
      maxDate.setMonth(maxDate.getMonth() - 216)
      maxDate.setDate(now.getDate())
      return maxDate
    },
    options () {
      return {
        tipoDoc: [
          { value: '01', text: 'C.C.' },
          { value: '02', text: 'C.E.' },
          { value: '06', text: 'PASAPORTE' }
        ],
        nivelEstudio: [
          { value: 1, text: 'BACHILLER' },
          { value: 2, text: 'TECNICO' },
          { value: 3, text: 'UNIVERSITARIO' },
          { value: 4, text: 'POSTGRADO' }
        ],
        tipoVivienda: [
          { value: 1, text: 'PROPIA' },
          { value: 2, text: 'FAMILIAR' },
          { value: 3, text: 'ARRENDADA' }
        ],
        estrato: [1, 2, 3, 4, 5, 6, 7],
        relacion: ['PADRE/MADRE', 'ABUELO(A)', 'TIO(A)', 'HERMANO(A)', 'PRIMO(A)'],
        genero: [{ value: 2, text: 'M' }, { value: 1, text: 'F' }],
        estadoCivil: [
          { text: 'SOLTERO(A)', value: 1 },
          { text: 'CASADO(A)', value: 2 },
          { text: 'VIUDO(A)', value: 3 },
          { text: 'DIVORCIADO(A)', value: 4 },
          { text: 'UNION LIBRE', value: 5 }
        ],
        ocupacion: [
          { value: 1, text: 'Empleado Formal' },
          { value: 2, text: 'Empleado Informal' },
          { value: 4, text: 'Independiente Formal' },
          { value: 9, text: 'Independiente Informal' }
        ],
        departamento: this.comboDeptos,
        ciudad: this.comboCiudades,
        barrio: this.comboBarrio,
        boxOne: ''
      }
    },
    comboDeptos () {
      const a = this.deptos.map(h => {
        return {
          item: h.codigo,
          name: h.nombre
        }
      })
      return a
    },
    comboCiudades () {
      const a = this.ciudades.filter(h => h.departamentoJoin.codigo === this.form.departamento)
      const b = a.map(h => {
        return {
          item: h.codigo,
          name: h.nombre
        }
      })
      return b
    },
    comboBarrio () {
      const a = this.barrios.map(h => {
        return {
          item: h.codigo,
          name: h.nombre
        }
      })
      return a
    },
    ...mapState({
      deptos: state => state.deptos,
      ciudades: state => state.ciudades,
      barrios: state => state.barrios
    })
  },
  methods: {
    siguiente () {
      let flag = false
      const tindex = this.tabIndex + 1
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      switch (this.tabIndex) {
        case 0:
          if (this.form.tipoDoc !== null &&
            (this.form.nroDoc !== null && this.form.nroDoc.trim() !== '') &&
            (this.form.lugarExp !== null && this.form.lugarExp.trim() !== '') &&
            this.form.fechaExp !== null &&
            (this.form.nombre1 !== null && this.form.nombre1.trim() !== '') &&
            (this.form.apellido1 !== null && this.form.apellido1.trim() !== '')) {
            flag = true
          }
          break
        case 1:
          if (this.form.fechaNac !== null &&
            (this.form.lugarNac !== null && this.form.lugarNac.trim() !== '') &&
            this.form.genero !== null &&
            this.form.estadoCivil !== null &&
            this.form.personasCargo !== null &&
            this.form.nivelEstudio !== null &&
            this.form.tipoVivienda !== null &&
            this.form.estrato !== null) {
            flag = true
          }
          break
        case 2:
          if ((this.form.ciudad !== null && this.form.ciudad.trim() !== '') &&
            (this.form.barrio !== null && this.form.barrio.trim() !== '') &&
            (this.form.direccion !== null && this.form.direccion.trim() !== '') &&
            (this.form.telefono1 !== null && this.form.telefono1.trim() !== '') &&
            (this.form.correo1 !== null && this.form.correo1.trim() !== '')) {
            flag = true
          }
          break
        case 3:
          if (
            (
              this.form.datosLab[0] !== new PersonaDatosLab()
            ) &&
            (
              this.form.datosFam[0] !== new PersonaDatosFam() &&
              this.form.datosFam[1] !== new PersonaDatosFam()
            ) &&
            (
              this.form.datosPer[0] !== new PersonaDatosPer() &&
              this.form.datosPer[1] !== new PersonaDatosPer()
            )
          ) {
            flag = true
          }
          break
      }
      if (flag === true) {
        this.tabIndex++
        if (this.tabs[tindex] === false) {
          setTimeout(function () { self.tabIndex++ }, 200)
        }
      } else {
        this.dismissCountDown = this.dismissSecs
      }
      this.tabs[tindex] = flag
    },
    enviar (e) {
      this.savePersona(this.form.datos).then(h => {
        if (h === true) {
          this.showMsgBoxOne()
        } else {
          this.showMsgBoxTwo()
        }
        return h
      })
      e.preventDefault()
    },
    showMsgBoxOne () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Registro Completado Satisfactoriamente',
        {
          title: 'Confirmación',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          this.boxOne = value
          this.tabs = [true, false, false, false, false]
          this.form = new Persona()
          this.$router.push({ path: '/solicitud' })
        })
        .catch(err => err)
    },
    showMsgBoxTwo () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Hubo un error al efectuar el registro. Verifique o comuniquese con el area soporte',
        {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          this.boxOne = value
          // this.$router.push({ path: '/solicitud' })
        })
        .catch(err => err)
    },
    ...mapActions(['savePersona'])
  },
  watch: {
    tabIndex (n, a) {
      if (this.tabs[n] === false) this.tabIndex = a
    }
  }
}
</script>
